
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {},
  layout: 'clean',
  fetch(ctx) {
    const query = ctx.query

    /**
     * t参数 是本站点授权时携带的参数
     * code参数 是微信完成登录后携带的参数
     *
     * 如果访问当前页面 但是既没有t参数也没有code参数 则不应该继续访问次页面 应当回到首页
     */
    if (!query.t && !query.code) {
      ctx.redirect('/')
      return
    }

    console.log(query)
  }
})
export default class Comp extends Vue {
  created() {
    if (this.$route.query.code) {
      // 微信授权登录成功回来
      window.opener.postMessage({
        type: 'wechat_auth_success',
        code: this.$route.query.code,
        state: this.$route.query.state
      })
    } else {
      // 回调地址
      const redirect = new URL('/auth/wechat', this.$store.$global.domain)

      // 跳转到微信授权页面
      const url = new URL('https://open.weixin.qq.com/connect/qrconnect')
      url.searchParams.set('appid', this.$store.$global.openAppid)
      url.searchParams.set('redirect_uri', redirect.toString())
      url.searchParams.set('response_type', 'code')
      url.searchParams.set('scope', 'snsapi_login')
      url.searchParams.set('state', `${this.$route.query.t}`)

      url.hash = '#wechat_redirect'

      location.href = url.toString()
    }
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
